// Presentation only: the provider's From header remains the mailbox name.
export function messageSenderLabel(message = {}) {
  const label = message.senderName || message.sender || '';
  const firstName = String(message.sentByUser?.firstName || '').trim();
  const actorId = String(message.sentByUserId || '');
  return message.type === 'OUTBOUND_EMAIL' && message.isAutomated !== true && firstName
    && actorId && actorId === String(message.sentByUser?.id || '')
    ? `${label} - ${firstName}` : label;
}
